// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 496) return "496_vendors.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"618":"37367f38","872":"bf0c0098"}[chunkId] + ".chunk.js";
};